module.exports = __webpack_public_path__ + "img/man_small.73e9a9ae.svg";